import React, { useEffect, useRef, useState } from "react";
import { Box, Text, IconButton, ActionList, ActionMenu } from "@primer/react";
import { PencilIcon, MailIcon, DeviceMobileIcon } from "@primer/octicons-react";
import { phuHuynhApi } from "../../api/phuHuynhApi";
import { useCommonContext } from "../../contexts/common";
import clsx from "clsx";
import UserAvatar from "../user-avatar";
import {
  KebabHorizontalIcon,
  PersonIcon,
  ChevronRightIcon,
  TrashIcon,
  BookIcon,
  TasklistIcon,
} from "@primer/octicons-react";

interface PhuHuynhInfoProps {
  id: number;
  isSelected: boolean;
  onSelected: () => void;
}

interface PhuHuynhData {
  id: number;
  ho_ten: string;
  email: string;
  dien_thoai: string;
  quan_he?: string;
}

const PhuHuynhInfo: React.FC<PhuHuynhInfoProps> = ({
  id,
  isSelected,
  onSelected,
}) => {
  const [formData, setFormData] = useState<PhuHuynhData | null>(null);
  const { translate } = useCommonContext();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const componentDidMount = useRef<boolean>(false);
  const [isShowEditModal, setIsShowEditModal] = useState<boolean>(false);

  useEffect(() => {
    componentDidMount.current = true;
    handleReloadData();
    return () => {
      componentDidMount.current = false;
    };
  }, [id]);

  const handleReloadData = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const res = await phuHuynhApi.getById(id);
      if (componentDidMount.current) {
        setIsLoading(false);
        if (res.is_success) {
          setFormData(res.data);
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error loading phu huynh details:", error);
    }
  };

  if (isLoading || !formData) return null;

  return (
    <ActionList>
      <ActionList.GroupHeading>Đang chọn</ActionList.GroupHeading>
      <ActionList.Item
        sx={{
          py: 2,
          backgroundColor: "accent.muted",
          cursor: isSelected ? "default" : "pointer",
          "&:hover": {
            backgroundColor: isSelected ? "accent.emphasis" : "bg.primary",
          },
          pointerEvents: isSelected ? "none" : "auto",
        }}
        onClick={isSelected ? undefined : onSelected}
      >
        <Box sx={{ display: "flex", width: "100%", mt:1 }}>
          {/* Left column for avatar and icons */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              mr: 2,
              minWidth: "32px",
            }}
          >
            <Box
              sx={{
                height: "24px",
                display: "flex",
                alignItems: "center",
                mb: 1,
              }}
            >
              <UserAvatar size="medium" fullName={formData.ho_ten} />
            </Box>
            <Box
              sx={{
                width: "100%",
                height: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1,
              }}
            >
              <MailIcon size={16} />
            </Box>
            <Box
              sx={{
                width: "100%",
                height: "24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <DeviceMobileIcon size={16} />
            </Box>
          </Box>

          {/* Right column for content */}
          <Box flex={1}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                height: "24px",
                mb: 1,
              }}
            >
              <Text fontWeight="bold">{formData.ho_ten}</Text>
              {formData.quan_he && (
                <Text
                  as="span"
                  sx={{
                    ml: 2,
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    fontSize: 0,
                    backgroundColor: "success.muted",
                    color: "success.fg",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  {formData.quan_he}
                </Text>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                height: "24px",
                mb: 1,
              }}
            >
              <Text fontSize={1}>{formData.email}</Text>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                height: "24px",
              }}
            >
              <Text fontSize={1}>{formData.dien_thoai}</Text>
            </Box>
          </Box>

          {/* Edit button */}
          {/* <Box sx={{ ml: 2 }}>
            <ActionMenu>
              <ActionMenu.Anchor>
                <IconButton
                  icon={KebabHorizontalIcon}
                  aria-label="More options"
                  variant="invisible"
                  disabled={isSelected}
                />
              </ActionMenu.Anchor>
              <ActionMenu.Overlay>
                <ActionList>
                  <ActionList.Item
                    variant="default"
                    onClick={(e) => {
                      e.stopPropagation();
                      setIsShowEditModal(true);
                    }}
                  >
                    <ActionList.LeadingVisual>
                      <PencilIcon />
                    </ActionList.LeadingVisual>
                    Chỉnh sửa
                  </ActionList.Item>
                </ActionList>
              </ActionMenu.Overlay>
            </ActionMenu>
          </Box> */}
        </Box>
      </ActionList.Item>

      {/* {isShowEditModal && (
                <PhuHuynhEditModal
                    phuHuynhId={formData?.id}
                    onCancel={() => setIsShowEditModal(false)}
                    onSuccess={() => {
                        setIsShowEditModal(false);
                        handleReloadData();
                    }}
                />
            )} */}
    </ActionList>
  );
};

export default PhuHuynhInfo;